import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/MetersService.ts";
import {useMetersSelection} from "../hooks/useMetersSelection.ts";
import {notifyError, notifySuccess} from "../../../components/ServiceNotifications";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useMetersSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: () => Promise.all(selectedRecords.map(record => deleteRecord(record.id))),
        onSuccess: () => {
            // Clear only once the deletes landed: a failed delete keeps the selection, so
            // the operator can see which rows it was and retry.
            clearSelection();
            notifySuccess(I18n.get('Meters deleted'));
            queryClient.invalidateQueries({queryKey: ['meters']});
        },
        onError: notifyError,
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
